import { getLocalGlobalState } from '@/utils'

export type UserState = {
  userInfo?: UserInfo
}
export const state: UserState = getLocalGlobalState()?.user || {}
